import { EPPAStep, IPPAPersonalIdentification, ISaveBasicInfo } from 'types/ppaOnboarding';
import { Request } from '../request';

export const getReviewData = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/uniprofile/review', scheduleToken });

export const saveStep = (step: EPPAStep | string, endFlag = false) =>
    Request.post({
        url: '/schedule-server/provider/step/save',
        params: {
            stepTypeEnum: 'KLARITY_ONBOARDING',
            currentStep: step,
            endFlag,
        },
    });

export const getStep = () => Request.get({ url: '/schedule-server/provider/step/stepinfo/KLARITY_ONBOARDING' });

export const savePPAOnboardingBasicInfo = (data: ISaveBasicInfo) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/basic/info/save', params: data });

export const getKlarityServiceSpecialtyList = () =>
    Request.get({ url: '/schedule-server/provider/onboarding/specialty/list' });

export const saveKlarityServiceSpecialty = (
    data: { recordType: 'KLARITY_ONBOARDING_SPECIALTY'; value: string },
    scheduleToken?: string,
) => Request.post({ url: '/schedule-server/common/provider/select/record/save', params: data, scheduleToken });

export const savePPAPaymentMethod = (supportPayType: string, scheduleToken?: string) =>
    Request.post({
        url: '/schedule-server/provider/uniprofile/insurance/save',
        params: { supportPayType },
        scheduleToken,
    });

export const getPPAServiceDetail = (scheduleToken?: string) =>
    Request.get({ url: '/schedule-server/provider/onboarding/service/detail', scheduleToken });

export const getPPAServicePriceConfig = (state: string[]) =>
    Request.post({ url: '/schedule-server/provider/klarity/service/price/list', params: state });

// export const savePPAServicePriceConfig = (data: string[]) => Request.post({ url: '/schedule-server/common/provider/select/record/save', params: data });
export const getTopProviders = () => Request.get({ url: '/schedule-server/provider/onboarding/top/provider' });

export const savePPAPersonalIdentification = (data: IPPAPersonalIdentification) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/license/save/batch', params: data });

export const submitReview = (data: { submitTime: string }) =>
    Request.post({ url: '/schedule-server/provider/uniprofile/submit', params: data });

export const submitInvitedProviderReview = (data: { submitTime: string }) =>
    Request.post({ url: '/schedule-server/provider/onboarding/invited-provider/submit', params: data });

export const savePaymentInfo = (data: { paymentMethodId: string }) =>
    Request.post({ url: '/schedule-server/provider/stripe/payment/info/save', params: data });

export const getDefaultPPAPaymentInfo = () =>
    Request.get({ url: '/schedule-server/provider/stripe/payment/info/default' });

export const updateLaunchTime = (expectLaunchTime: string) =>
    Request.post({ url: '/schedule-server/provider/onboarding/expectLaunchTime/update', params: { expectLaunchTime } });

export const joinKlarityHealth = (paymentMethodId: string) =>
    Request.post({ url: '/schedule-server/provider/onboarding/join/klarity/health', params: { paymentMethodId } });

// 已填过卡但还没 list（ppaProvider=false）：不再新增付款方式，直接用已有卡 list on Klarity Health
export const joinKlarityHealthWithoutPayment = () =>
    Request.post({ url: '/schedule-server/provider/onboarding/join/klarity/health/without-payment' });

export const getPPALeadGenFee = () =>
    Request.get({ url: '/schedule-server/provider/klarity/service/lead-gen-fee/onboarding' });

// export const getOpenAiAboutMe = () => Request.get({ url: '/schedule-server/common/provider/select/record/OPEN_AI_ABOUT_ME' });

// export const saveOpenAiAboutMe = (data: {
//     recordType: 'OPEN_AI_ABOUT_ME',
//     value: string,
// }) => Request.post({ url: '/schedule-server/common/provider/select/record/save', params: data });
